<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-csm__platform">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.status" placeholder="请选择状态">
                        <el-option
                                v-for="item in allStatus"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button  v-if="$hasPermission('csm:platform:update')" type="primary"  @click="batchUpdateHandle()">批量审核
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('csm:platform:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('csm:platform:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
                <!--        </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="integrationAmount" label="优果数量" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="bankAccountName" label="银行开户名" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="bankName" label="银行名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="bankCardNumber" label="银行卡号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="branch" label="开户支行" header-align="center" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" header-align="center" align="center">
                    <template slot-scope="scop">
                        <el-tag v-if="scop.row.status==0" type="success" size="small">待处理</el-tag>
                        <el-tag v-else-if="scop.row.status==1" type="success" size="small">已通过</el-tag>
                        <el-tag v-else-if="scop.row.status==2" type="success" size="small">已拒绝</el-tag>
                        <el-tag v-else-if="scop.row.status==3" type="success" size="small">已取消</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
                <el-table-column label="审批" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status==0" type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">审批
                        </el-button>
                        <!--            <el-button v-if="$hasPermission('csm:platform:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <BatchUpdate v-if="batchUpdateVisible" ref="BatchUpdate" @refreshDataList="getDataList"></BatchUpdate>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './platform-add-or-update'
    import BatchUpdate from  './platform-batch-update'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                batchUpdateVisible:false,
                mixinViewModuleOptions: {
                    getDataListURL: '/csm/platform/page',
                    getDataListIsPage: true,
                    exportURL: '/csm/platform/export',
                    deleteURL: '/csm/platform',
                    deleteIsBatch: true
                },
                allStatus: [{
                    value: '',
                    label: ''
                }, {
                    value: 0,
                    label: '待处理'
                }, {
                    value: 1,
                    label: '已通过'
                }, {
                    value: 2,
                    label: '已拒绝'
                }, {
                    value: 3,
                    label: '已取消'
                }],
                dataForm: {
                    mobileNumber: '',
                    memberName: '',
                    status: '',
                    beginDate: "",
                    endDate:"",
                }
            }
        },
        created() {
            let d = new Date
            d.setDate(d.getDate()-1);
            //d.setTime(d.getTime()-24*30*60*60*1000);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0)
            this.dataForm.beginDate=d
        },
        methods:{
            batchUpdateHandle(){
                if ( this.dataListSelections.length <= 0) {
                    return this.$message({
                        message: '请选择银商管理项',
                        type: 'warning',
                        duration: 1000
                    })
                }
                for(let i=0;i<this.dataListSelections.length;i++) {
                    if(this.dataListSelections[i].status!==0){
                        let mobileNumber=this.dataListSelections[i].mobileNumber;
                        return this.$message({
                            message: mobileNumber+'不为待审核阶段',
                            type: 'warning',
                            duration: 1000
                        })
                    }
                }
                let ids= this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
                this.batchUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.BatchUpdate.dataForm.ids = ids
                    this.$refs.BatchUpdate.init()
                })
            }
        },
        components: {
            AddOrUpdate,
            BatchUpdate
        }
    }
</script>
